import { _request, APIBaseResponse, APIMethod } from '../';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const ACL_RESOURCES_PATH_PREFIX = 'aclresources';

type APIAclResourcesGetParams = RequestParamsBase & {
    tenantId: string;
};

type APIAclResourcesGetSingleParams = RequestParamsBase & {
    tenantId: string;
    id: string;
}

export type AclResourcesPostProperties = {
    permissions: string[];
};

export type AclResource = {
    tenantId: string;
    id: string;
    name: string;
    displayName: string;
    conditions?: string[];
};

export type APIAclResourcesGetResponse = APIBaseResponse<Array<AclResource>>;

type APIAclResourceDeleteResponse = APIBaseResponse<''>;

type APIAclResourceDeleteParams = {
    id: string;
    tenantId: string;
};

export type APIAclResourcePostParams = {
    name: string;
    displayName: string | undefined;
    tenantId: string;
    conditions?: string[];
};
export type APIAclResourcePostResponse = APIBaseResponse<{
    aclResourceId: string;
}>;

export const APIAclResourceGetList: APIMethod<APIAclResourcesGetParams, APIAclResourcesGetResponse> = (params: APIAclResourcesGetParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACL_RESOURCES_PATH_PREFIX}`, undefined, params.signal)
);

export const APIAclResourceGet: APIMethod<APIAclResourcesGetSingleParams, APIBaseResponse<AclResource>> = (params: APIAclResourcesGetSingleParams) => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACL_RESOURCES_PATH_PREFIX}/${params.id}`, undefined, params.signal)
);

export const APIAclResourceDelete: APIMethod<APIAclResourceDeleteParams, APIAclResourceDeleteResponse> = (params: APIAclResourceDeleteParams) => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACL_RESOURCES_PATH_PREFIX}/${params.id}`));

export const APIAclResourcePost: APIMethod<APIAclResourcePostParams, APIAclResourcePostResponse> = (params) => (
    _request<APIAclResourcePostResponse>('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACL_RESOURCES_PATH_PREFIX}`, {
        name: params.name,
        displayName: params.displayName,
        tenantId: params.tenantId,
        conditions: params.conditions
    })
);

export type APIAclResourcePutParams = {
    tenantId: string;
    id: string
    name: string;
    displayName: string | null;
    conditions?: string[];
};

export type APIAclResourcePutResponse = APIBaseResponse;

export const APIAclResourcePut: APIMethod<APIAclResourcePutParams, APIAclResourcePutResponse> = (params: APIAclResourcePutParams) => (
    _request<APIAclResourcePutResponse>(
        'PUT',
        `${TENANTS_PATH_PREFIX}/${params.tenantId}/${ACL_RESOURCES_PATH_PREFIX}/${params.id}`,
        params)
);
